import { apiClient } from "@config/apiClient";
import { IPeople } from "@interfaces/people.interface";
import { IPagedResponse } from "@interfaces/responses.interface";
import { API_URL } from "@config/constants";

class PeopleService {
  private URL = `${API_URL}/people`;

  async searchPeople(params: URLSearchParams): Promise<IPagedResponse<IPeople>> {
    return apiClient.get(`${this.URL}/people/?${params.toString()}`);
  }

  async activatePerson(personId: string, meetingId: string): Promise<{}> {
    return apiClient.post(`${this.URL}/people/${personId}/activate/?include_suggested=true`, {
      meeting: meetingId,
    });
  }
}

const peopleService = new PeopleService();
export default peopleService;
